export class Necessidade {
    id: number;    
    descricao: string;
}